import { nextApiEndpoint } from '@/constant/env';

import { Logger } from '../Logging';
import { TIMEOUT_DURATIONS } from './constants';
import { Experiment, ExperimentsApiResponse } from './types';

const logger = new Logger('experimentation/loadExperiments.ts');

export const loadExperiments = async (): Promise<Experiment[]> => {
  if (!nextApiEndpoint) {
    return [];
  }

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(
      () => controller.abort(),
      TIMEOUT_DURATIONS.DEFAULT_REQUEST
    );

    const response = await fetch(`${nextApiEndpoint}/experiments`, {
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      logger.error({
        message: 'Failed to fetch experiments',
        context: {
          status: response.status,
          statusText: response.statusText,
        },
      });
      return [];
    }

    const resJson = (await response.json()) as ExperimentsApiResponse;
    const experiments = resJson?.data;

    if (!experiments || !Array.isArray(experiments)) {
      logger.error({
        message: 'Invalid experiments response format',
        context: {
          responseBody: resJson,
          status: response.status,
        },
      });
      return [];
    }

    return experiments?.filter((experiment) => experiment.enabled) || [];
  } catch (error) {
    logger.error({
      message: 'Error loading experiments',
      context: error,
    });
    return [];
  }
};
